import React, { useEffect, useState } from "react";
import '../../../../assets/css/valuelist.css';
import MainWrapper from "../../../MainWrapper";
import { Link, Navigate } from "react-router-dom";
import Icon from "react-icons-kit";
import { ic_arrow_back, ic_mode_edit, ic_save } from 'react-icons-kit/md';
import { Table, Form, Button, InputGroup } from 'react-bootstrap';
// import { encrypted } from '../../../../_utils/helpers';
import { connect } from 'react-redux';
import Create from "./models/Create";
import ConfirmDelete from "./models/ConfirmDelete";
import {
  PROPERTY_REQUEST,
  PROPERTY_CREATE,
  PROPERTY_DELETE,
  PROPERTY_EDIT,
  PROPERTY_STATE_CHANGE
} from "../../../../_utils/constants/ProductCatalog";
import Loader from "../../../layouts/Loader";
import { toast } from 'react-toastify';

const Property = ({
  auth: { auth, isAuthenticated },
  Property: { valueList, isCreated, isDeleted, isEdited, isLoading },
  fetchProperty,
  submitPropertyCreate,
  submitPropertyDelete,
  submitPropertyEdit,
  changeReducerState
}) => {

  // states declarations
  const [createModalOpen, setCreateModalOpen] = useState(false);
  const [confirmDeleteModal, setConfirmDeleteModal] = useState(false);
  const [inputVal, setInputVal] = useState('');
  const [deletePropertyId, setDeletePropertyId] = useState('');
  const [editPropertyId, setEditPropertyId] = useState('');
  const [editProperty, setEditProperty] = useState('');

  // use effect function called for authentication
  useEffect(() => {
    if (isAuthenticated) {
      fetchProperty(auth[0].token);
    }
  }, [auth, isAuthenticated]);

  // use effect function called after api success
  useEffect(() => {
    if (isCreated === true) {
      toast.success("Property Created Successfully.");
      fetchProperty(auth[0].token);
      changeReducerState();
    }
    if (isDeleted === true) {
      toast.success("Property Deleted Successfully.");
      fetchProperty(auth[0].token);
      changeReducerState();
    }
    if (isEdited === true) {
      toast.success("Property Data Updated Successfully.");
      fetchProperty(auth[0].token);
      changeReducerState();
    }
  }, [isCreated, isDeleted, isEdited]);

  // function to open create modal
  const showCreateModal = () => {
    setCreateModalOpen(true);
  };

  // function to close create modal
  const hideCreateModal = () => {
    setCreateModalOpen(false);
  };

  // function called for input value change of create modal
  const handleCreateModalChange = (e) => {
    setInputVal(e.target.value);
  }

  // function called for create age demographic create api
  const handleCreateModalSubmit = (e) => {
    e.preventDefault();
    if (inputVal === '') {
      toast.error("Property name cannot be empty.");
    } else {
      submitPropertyCreate({
        "data": {
          "Property": inputVal,
        },
        "token": auth[0].token
      });
      hideCreateModal();
    }
  }

  // function to open confirm delete modal
  const showConfirmDeleteModal = (id) => {
    setDeletePropertyId(id);
    setConfirmDeleteModal(true);
  };

  // function to close confirm delete modal
  const hideConfirmDeleteModal = () => {
    setDeletePropertyId('');
    setConfirmDeleteModal(false);
  };

  // function called for delete age demographic delete api
  const handleConfirmDeleteSubmit = () => {
    submitPropertyDelete({
      "PropertyId": deletePropertyId,
      "token": auth[0].token
    });
    hideConfirmDeleteModal();
  }

  // function called on edit icon click
  const handleEditClick = (data) => {
    setEditPropertyId(data.propertyId);
    setEditProperty(data.property);
  }

  // function called to save edited data
  const handleEditSaveClick = (data) => {
    if (editProperty === '') {
      toast.error("Property name cannot be empty.");
    } else {
      submitPropertyEdit({
        "data": {
          "PropertyId": data.propertyId,
          "Property": editProperty,
        },
        "token": auth[0].token
      });
      setEditPropertyId('');
      setEditProperty('');
    }
  }

  if (!isAuthenticated) return <Navigate to="/login" />;

  return (
    <MainWrapper>
      <Loader loading={isLoading}>
        <div className="container">

          <div className="sub-header mt-5 mb-3">
            <h2>Property</h2>
            <Link className="btn btn-primary me-1" to="/admin"><Icon icon={ic_arrow_back} />Back to Value List</Link>
            <Create
              variant="primary"
              title={`Property`}
              createModalOpen={createModalOpen}
              showCreateModal={showCreateModal}
              hideCreateModal={hideCreateModal}
              inputVal={inputVal}
              handleCreateModalChange={handleCreateModalChange}
              handleCreateModalSubmit={handleCreateModalSubmit}
            />
          </div>
          <Table responsive bordered>
            <thead>
              <tr>
                <th>Property</th>
                <th width="50">Delete</th>
              </tr>
            </thead>
            <tbody>
              {valueList && valueList.length > 0 ? (
                valueList.map((item, index) => (
                  <tr key={index}>
                    {editPropertyId === item.propertyId ? (
                      <td>
                        <Form.Group>
                          <InputGroup>
                            <Form.Control type="text" value={editProperty} onChange={(evt) => setEditProperty(evt.target.value)} />
                            <Button variant="outline-secondary">
                              <Icon size={24} icon={ic_save} onClick={() => handleEditSaveClick(item)} />
                            </Button>
                          </InputGroup>
                        </Form.Group>
                      </td>
                    ) : (
                      <td>
                        {item.property}
                        <Icon role="button" className="float-end" size={24} icon={ic_mode_edit} onClick={() => handleEditClick(item)} />
                      </td>
                    )}
                    <td>
                      <ConfirmDelete variant="primary" title={`Property`} showConfirmDeleteModal={() => showConfirmDeleteModal(item.propertyId)} hideConfirmDeleteModal={hideConfirmDeleteModal} handleConfirmDeleteSubmit={handleConfirmDeleteSubmit} confirmDeleteModal={confirmDeleteModal} />
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={2}>
                    No Data Found.
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </Loader>
    </MainWrapper>
  );
}

const mapStateToProps = ({ auth, Property }) => {
  return {
    auth,
    Property
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    fetchProperty: (token) => dispatch({ type: PROPERTY_REQUEST, token }),
    submitPropertyCreate: (data) => dispatch({ type: PROPERTY_CREATE, payload: data }),
    submitPropertyDelete: (data) => dispatch({ type: PROPERTY_DELETE, payload: data }),
    submitPropertyEdit: (data) => dispatch({ type: PROPERTY_EDIT, payload: data }),
    changeReducerState: () => dispatch({ type: PROPERTY_STATE_CHANGE })
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Property);